import { Flex } from 'antd';

import { ReactComponent } from '../../../public/logo-white.svg';

const Logo = () => (
  <Flex align="center" justify="center">
    <ReactComponent style={{ height: 32 }} />
  </Flex>
);

export default Logo;
